import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../ui/card';

/**
 * Shared panel wrapper for every simulator chart — matches the `.technical-card` +
 * font-chivo uppercase title convention used by the standalone tool result cards
 * (EvMotorSizingCalculator, EvBatterySizingCalculator) rather than a generic new style.
 */
const ChartCard = ({ icon: Icon, title, description, children, testId, className = '' }) => (
  <Card className={`technical-card ${className}`} data-testid={testId}>
    <CardHeader>
      <CardTitle className="font-chivo uppercase tracking-tight text-base flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4 text-autoxium-blue" />}
        {title}
      </CardTitle>
      {description && <CardDescription>{description}</CardDescription>}
    </CardHeader>
    <CardContent>{children}</CardContent>
  </Card>
);

export default ChartCard;
